import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import { formatDate } from "../../Helper/Helper";

function SideImageHomeNews() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    getNewsData();
  }, []);

  const getNewsData = async () => {
    try {
      const response = await SendPostRequest("news/list");
      if (response?.data && response.data.length > 0) {
        setNewsData(response.data);
        setHasData(true);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching news data:", error);
      setLoading(false);
    }
  };

  const leftColumnItems = newsData.slice(0, Math.ceil(newsData.length / 2));
  const rightColumnItems = newsData.slice(Math.ceil(newsData.length / 2));

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <>
      {loading ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "300px" }}
        >
          <Spinner />
        </div>
      ) : hasData ? (
        <div
          className="blog-section section-bg-img py-5 mb-5 mt-5"
          // style={{ backgroundImage: 'url("/assets/images/bg/bg-34.jpg")' }}
          style={{ backgroundImage: 'url("/assets/images/mist/home-news-side-img-bg.webp")' }}
        >

          <div className="container">
            <div className="row blog-list blog-list-style-1 br-style">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center mb-2">
                  <div className="section-title mb-0">
                    <h2 className="section-title mb-0 typo-white text-uppercase">
                      Latest News<span className="theme-color"></span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>

              <div className="blog-section pt-5">
                <div className="row blog-list blog-list-style-1 br-style">
                  {newsData?.slice(0, 8)?.map((item, index) => (
                    <div className="col-md-6 mb-5" data-animation="fadeInLeft" key={index}>
                      <div className="blog-inner" style={{ borderBottom: "1px dotted #eaeaea", paddingBottom: isMobile ? "5px" : "30px", }}>
                        <div className="media list-post">
                          <div className="blog-thumb relative">
                            <img
                              src={item?.image || "images/blog/blog-list/blog-1.jpg"}
                              className="img-fluid"
                              style={{ width: isMobile ? "100%" : "100%", height: isMobile ? "auto" : "auto", marginBottom: isMobile ? "15px" : "0px", }}
                              alt="blog-img"
                            />
                          </div>
                          <div className="media-body">
                            <div className="top-meta margin-bottom-10">
                              <ul className="top-meta-list">
                                <li>
                                  <div className="post-date text-white">
                                    <Link className=" text-white side-img-news-date" to={`/news/detail/${item?.slug}`}>
                                      <i className="ti-calendar text-white"></i> {formatDate(item?.date)}
                                    </Link>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="blog-title ">
                              <h5 className="margin-bottom-5">
                                <Link
                                  to={`/news/detail/${item?.slug}`}
                                  className="blog-name text-white"
                                >
                                  {item?.title}
                                </Link>
                              </h5>
                            </div>
                            <div className="entry-content typo-white">
                              <p className="mb-0"

                                dangerouslySetInnerHTML={{
                                  __html: (() => {
                                    const plainText = item?.content?.replace(/<[^>]*>/g, "") || "";
                                    const truncated = plainText.length > 85
                                      ? plainText.substring(0, 85) + "..."
                                      : plainText;
                                    return truncated;
                                  })()
                                }}>
                                {/* {item?.content
                                  ?.replace(/<[^>]*>/g, "")
                                  .substring(0, 85)}
                                ... */}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* <div className="col-md-6" data-animation="fadeInLeft">
                {leftColumnItems.map((item, index) => (
                  <div className="blog-inner animated fadeInUp visible" key={`left-${index}`}>
                    <div className="media list-post">
                      <div className="blog-thumb relative">
                        <img
                          src={
                            item?.image || "images/blog/blog-list/blog-1.jpg"
                          }
                          className="img-fluid"
                          style={{ width: "130px", height: "130px" }}
                          alt="blog-img"
                        />
                      </div>
                      <div className="media-body">
                        <div className="blog-title typo-white">
                          <h4 className="margin-bottom-5">
                            <Link
                              to={`/news/detail/${item?.slug}`}
                              className="blog-name"
                            >
                              {item?.title}
                            </Link>
                          </h4>
                        </div>
                        <div className="entry-content typo-white">
                          <p className="mb-0">
                            {item?.content
                              ?.replace(/<[^>]*>/g, "")
                              .substring(0, 100)}
                            ...
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-md-6" data-animation="fadeInRight">
                {rightColumnItems.map((item, index) => (
                  <div className="blog-inner animated fadeInUp visible" key={`right-${index}`}>
                    <div className="media list-post">
                      <div className="blog-thumb relative">
                        <img
                          src={
                            item?.image || "images/blog/blog-list/blog-1.jpg"
                          }
                          className="img-fluid"
                          style={{ width: "130px", height: "130px" }}
                          alt="blog-img"
                        />
                      </div>
                      <div className="media-body">
                        <div className="blog-title typo-white">
                          <h4 className="margin-bottom-5">
                            <Link
                              to={`/news/detail/${item?.slug}`}
                              className="blog-name"
                            >
                              {item?.title}
                            </Link>
                          </h4>
                        </div>
                        <div className="entry-content typo-white">
                          <p className="mb-0">
                            {item?.content
                              ?.replace(/<[^>]*>/g, "")
                              .substring(0, 100)}
                            ...
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default SideImageHomeNews;
